export const convertArrayString = (arrStr = '[]') => {
    const content = arrStr.replace(/\[|\]/gi, '');
    const arr = content.split(',').map((value) => value.trim());
    return arr.filter((entry) => entry);
};
